<template>
  <!-- Holter出荷指示書表示 -->
  <div id="HolterShippingDirectionsView">
    <div id="container">
      <div class="labelTitle lable">出荷指示リスト</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>出荷予定日</th>
            <td><input type="date" v-model="searchConditions.shippingDate"/></td>
            <th>機種</th>
            <td style="border-right:hidden;width:450px;"><select v-model="searchConditions.instrumentKind"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <th style="background-color:white;border-right:hidden;"></th>
            <td style="border-right:hidden;"></td>
            <th style="background-color:white;border-right:hidden;"></th>
            <td></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">表示</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <div class="labelTitle lable subTitle" v-if="isShow">{{titleMsg}}</div>
      <div class="button-area" v-if="isShow">
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
      </div>
      <div class="result-area" v-if="isShow">
        <b-table
            id="shippingDirectionsViewTable"
            :data="data"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="hstRequestFlag" label="WP300同梱の有無" width="40" centered>
                <span v-if="props.row.hstRequestFlag">有</span><span v-else>無</span>
              </b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="60" centered>{{props.row.receiptNumber}}</b-table-column>
              <b-table-column field="serial" label="機器シリアル" width="60" centered>{{props.row.serial}}</b-table-column>
              <b-table-column field="inspectionPeriod" label="検査期間" width="50" centered>{{props.row.dispInspectionPeriod}}</b-table-column>
              <b-table-column field="lot1" label="パッチ/ロット①" width="60" centered>{{props.row.patchlot1}}</b-table-column>
              <b-table-column field="lot2" label="パッチ/ロット②" width="60" centered>{{props.row.patchlot2}}</b-table-column>
              <b-table-column field="lot3" label="パッチ/ロット③" width="60" centered>{{props.row.patchlot3}}</b-table-column>
              <b-table-column field="wireLot" label="ワイヤー/ロット" width="70" centered>N/A</b-table-column>
              <b-table-column field="familyName" label="姓" width="20" centered>{{props.row.familyName}}</b-table-column>
              <b-table-column field="firstName" label="名" width="20" centered >{{props.row.firstName}}</b-table-column>
              <b-table-column field="dispoElectrodePatch" label="ディスポ電極パッチ" width="90">{{props.row.electrodePatch}}</b-table-column>
              <b-table-column field="seishikimen" label="清拭綿" width="40">{{props.row.seishikimen}}</b-table-column>
              <b-table-column field="guide" label="ガイド" width="40">{{props.row.guide}}</b-table-column>
              <b-table-column field="phoneNumber" label="連絡先" width="50" centered>{{props.row.phoneNumber}}</b-table-column>
              <b-table-column field="zip" label="郵便番号" width="50" centered>{{props.row.zip}}</b-table-column>
              <b-table-column field="receiverAddress" label="住所" width="160">{{props.row.receiverAddress}}</b-table-column>
              <b-table-column field="receiverName" label="配送先宛名" width="130">{{props.row.receiverName}}</b-table-column>
              <b-table-column field="deliveryDate" label="納品日" width="80">{{props.row.deliveryDate}}</b-table-column>
              <b-table-column field="desiredDeliveryTimeZone" label="配達希望時間" width="60">{{props.row.desiredDeliveryTimeZone | getNameFilter(desiredDeliveryTimeZoneList)}}</b-table-column>
              <b-table-column field="biko" label="備考" width="150">{{props.row.biko}}</b-table-column>

              <!--
              <b-table-column field="receiverAddress" label="取扱説明書" ></b-table-column>
              <b-table-column field="deliveryDate" label="案内文" width="80" centered></b-table-column>
              -->
            </template>
        </b-table>
    　</div>
        <div class="button-area" v-if="isShow">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
export default {
  name: "HolterShippingDirectionsView",
  methods: {
    doSearch: function (){
      if(!this.searchConditions.shippingDate){
        this.showErrorMessage("出荷予定日を選択してください。")
        return;
      }
      this.data = []
      this.isShow = false
      var excuteApi = this.getHolterShippingDirectionsListPOST;
      var successCallBack = this.getHolterShippingDirectionsListPOSTSuccess;
      var errorCallBack = this.getHolterShippingDirectionsListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterShippingDirectionsListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      return client.apis.internalHolter.getHolterShippingDirectionsListPOST({
        body:obj
      });
    },
    getHolterShippingDirectionsListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        var date = this.searchConditions.shippingDate.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1年$2月$3日');
        var targetModel = this.modelList.find(item => item.value == this.searchConditions.instrumentKind)
        this.titleMsg = date + " " + (targetModel ? targetModel.label1 : "" ) + "出荷指示リスト"
        this.isShow = true;
      }
    },
    getHolterShippingDirectionsListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      this.$router.push({
        name: "HolterShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    clipboardCopy: function() {
      var btable = document.getElementById('shippingDirectionsViewTable');
      var tableWrapper = btable.getElementsByClassName('table-wrapper')[0];
      var table = tableWrapper.getElementsByTagName('table')[0];
      var tbody = table.getElementsByTagName('tbody')[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
  },
  data() {
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    return {
      atLaunchHidden: atLaunchHidden,
      searchConditions:{
        shippingDate:"",
        instrumentKind:modelList[0].value
      },
      searchParams,
      data: [],
      isShow: false,
      modelList,
      desiredDeliveryTimeZoneList,
      cannulaSizeList,
      beltSizeList,
      titleMsg:""
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.subTitle,
.result-area {
  margin-top: 20px;
  width:1400px;
}
.result-area {
  max-height: 650px;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/shipping/HolterShippingDirectionsView.vue